import { defineStore } from "pinia";
import state from "./state";
import actions from "./actions";
import getters from "./getters";

export const useAdminStore = defineStore("admin", {
  state,
  getters,
  actions: actions(),
});
